<form nz-form [formGroup]="formGroup" (ngSubmit)="submit()">
  <div nz-row [nzGutter]="[24, 24]">
    <nz-col [nzSpan]="mode === 'edit' ? 12 : 24">
      <div class="page-content-section">
        <fieldset>
          <legend>{{'Attribute Set Information'  | translate}}</legend>
          <nz-form-item *ngIf="mode === 'edit'">
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              nzRequired
              [nzNoColon]="true"
              nzFor="Code"
            >
              {{'Id'  | translate}}
            </nz-form-label>
            <nz-form-control
              [nzSm]="24"
              [nzXs]="24"
              [nzErrorTip]="'Please insert the id.'  | translate"
            >
              <input nz-input formControlName="Id" id="Id" readonly />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              nzRequired
              [nzNoColon]="true"
              nzFor="Name"
            >
              {{'Name'  | translate}}
            </nz-form-label>
            <nz-form-control
              [nzSm]="24"
              [nzXs]="24"
              [nzErrorTip]="'Please insert the attribute set name.'  | translate"
            >
              <input nz-input formControlName="Name" id="Name" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              [nzNoColon]="true"
              nzFor="Description"
            >
              {{'Description' | translate}}
            </nz-form-label>
            <nz-form-control
              [nzSm]="24"
              [nzXs]="24"
              [nzErrorTip]="'Please insert the attribute set description.'  | translate"
            >
              <input nz-input formControlName="Description" id="Description" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label
              [nzSm]="24"
              [nzXs]="24"
              [nzNoColon]="true"
              nzFor="IsDefault"
            >
              {{'Is Default Set' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzXs]="24">
              <nz-select [nzAllowClear]="true" formControlName="IsDefault" id="IsDefault">
                <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                <nz-option [nzValue]="false" nzLabel="No"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </fieldset>
      </div>
    </nz-col>
    <nz-col [nzSpan]="12" *ngIf="mode === 'edit'">
      <div class="page-content-section attributes-tree">
        <fieldset>
          <legend>{{'Groups' | translate}}</legend>
          <nz-space style="width: 100%" nzDirection="vertical">
            <nz-list
            class="groups-list"
              cdkDropList
              (cdkDropListDropped)="dropGroup($event)"
              [nzLoading]="groupsLoading"
            >
              <nz-list-item *ngFor="let group of AttributeGroups">
                <div
                  cdkDrag
                  cdkDragLockAxis="y"
                  class="editable-cell"
                  [hidden]="editId === group.Id"
                  (click)="startEditGroup(group.Id!, groupNameInput)"
                  #groupNameInput
                >
                  {{ group.Name }}
                </div>
                <input
                  [hidden]="editId !== group.Id"
                  type="text"
                  nz-input
                  [ngModel]="group.Name"
                  [ngModelOptions]="{ standalone: true }"
                  (blur)="editGroupName($event, group)"
                />
                <!-- {{ group.Name }} -->
                <ul nz-list-item-actions>
                  <nz-list-item-action>
                    <button
                      nz-button
                      nzDanger
                      type="button"
                      class="border-radius"
                      nz-popconfirm
                      [nzPopconfirmTitle]="
                        'Are you sure delete this group?' | locale
                      "
                      (nzOnConfirm)="deleteGroup(group.Id!)"
                    >
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                    </button>
                  </nz-list-item-action>
                </ul>
              </nz-list-item>
            </nz-list>
            <nz-input-group
              [nzAddOnAfter]="submitGroupTemp"
              *ngIf="showGroupInput"
            >
              <input
                type="text"
                nz-input
                [(ngModel)]="tempAttributeGroup.Name"
                [ngModelOptions]="{ standalone: true }"
                placeholder="write group name"
              />
            </nz-input-group>
            <ng-template #submitGroupTemp>
              <button
                type="button"
                nz-button
                nzType="primary"
                nzSearch
                (click)="submitNewGroup()"
              >
                {{'Save' | translate}}
              </button>
            </ng-template>

            <button
              nz-button
              type="button"
              style="width: 100%"
              (click)="addNewGroup()"
            >
              <span nz-icon nzType="plus" nzTheme="outline"></span>
              {{'Create Group' | translate}}
            </button>
          </nz-space>
        </fieldset>
      </div>
    </nz-col>
  </div>
  <input type="submit" style="display: none" />
</form>
